import { fork, takeLatest, take } from 'redux-saga/effects';
import _ from 'lodash';
import {
    OPEN_ERROR_MODAL,
    CLOSE_MODAL_READY
} from '../iwModals/Modals.actions';
import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import { REPLACE_ROUTER } from '../iwRouter/IwRouter.actions';
import {
    UPLOAD_DOCUMENT,
    UPDATE_DOCUMENT_STATUS_ON_COMPLETED
} from '../myAccount/modals/uploadDocumentsModal/UploadDocumentsModal.actions';

export const trackingSagaWorkers = [
    fork(trackErrorModalWorker),
    fork(trackModalWorker),
    fork(trackDocumentUploadWorker)
];

function* trackErrorModalWorker() {
    yield takeLatest(OPEN_ERROR_MODAL, function* ({ id }) {
        yield GoogleTagManager.trackError({
            identifier: id
        });
    });
}

function* trackModalWorker() {
    yield takeLatest(REPLACE_ROUTER, function* (action) {
        const searchString = _.get(action, 'location.search', '');
        const modalNameMatch = searchString.match(/\?modal=(.+)/);

        if (_.get(modalNameMatch, 'length', 0) < 2) return;

        const modalName = modalNameMatch[1];
        GoogleTagManager.trackModal({
            interaction: 'Open',
            modalName
        });

        yield take(CLOSE_MODAL_READY);

        GoogleTagManager.trackModal({
            interaction: 'Close',
            modalName
        });
    });
}

function* trackDocumentUploadWorker() {
    yield takeLatest(UPLOAD_DOCUMENT, function* (action) {
        const documentType = _.get(action, 'documentType.label');

        yield take(UPDATE_DOCUMENT_STATUS_ON_COMPLETED);

        GoogleTagManager.trackEvent({
            event: 'Upload document',
            label: documentType
        });
    });
}
